/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RocketOrderSummaryInfoVo } from './RocketOrderSummaryInfoVo';
import {
    RocketOrderSummaryInfoVoFromJSON,
    RocketOrderSummaryInfoVoFromJSONTyped,
    RocketOrderSummaryInfoVoToJSON,
    RocketOrderSummaryInfoVoToJSONTyped,
} from './RocketOrderSummaryInfoVo';

/**
 * 
 * @export
 * @interface ResponseListRocketOrderSummaryInfoVo
 */
export interface ResponseListRocketOrderSummaryInfoVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListRocketOrderSummaryInfoVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListRocketOrderSummaryInfoVo
     */
    message?: string;
    /**
     * 
     * @type {Array<RocketOrderSummaryInfoVo>}
     * @memberof ResponseListRocketOrderSummaryInfoVo
     */
    data?: Array<RocketOrderSummaryInfoVo>;
}

/**
 * Check if a given object implements the ResponseListRocketOrderSummaryInfoVo interface.
 */
export function instanceOfResponseListRocketOrderSummaryInfoVo(value: object): value is ResponseListRocketOrderSummaryInfoVo {
    return true;
}

export function ResponseListRocketOrderSummaryInfoVoFromJSON(json: any): ResponseListRocketOrderSummaryInfoVo {
    return ResponseListRocketOrderSummaryInfoVoFromJSONTyped(json, false);
}

export function ResponseListRocketOrderSummaryInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListRocketOrderSummaryInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(RocketOrderSummaryInfoVoFromJSON)),
    };
}

export function ResponseListRocketOrderSummaryInfoVoToJSON(json: any): ResponseListRocketOrderSummaryInfoVo {
    return ResponseListRocketOrderSummaryInfoVoToJSONTyped(json, false);
}

export function ResponseListRocketOrderSummaryInfoVoToJSONTyped(value?: ResponseListRocketOrderSummaryInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(RocketOrderSummaryInfoVoToJSON)),
    };
}

